// Finance hosts TWO agents: 'finance_chat' (normal advisory chat, finance lens —
// the tab's default) and 'credit_agricole' (the structured guided assessment,
// started only via "Start a guided assessment"). Both map to the finance domain.
export const domainForAgent = (agentId) => (agentId === 'credit_agricole' || agentId === 'finance_chat') ? 'finance' : agentId === 'market' ? 'market' : 'agri';
export const modeForAgent = (agentId) => agentId === 'credit_agricole' ? 'credit' : agentId === 'market' ? 'market' : 'default';
// Entering the Finance tab starts a normal chat; the guided assessment switches
// the agent to 'credit_agricole' on demand (see chooseTask in Chat.jsx).
export const agentForDomain = (domain) => domain === 'finance' ? 'finance_chat' : domain === 'market' ? 'market' : 'default';

export const inferConversationAgentId = (conversation) => {
  if (conversation?.agent_id) return conversation.agent_id;
  for (const message of conversation?.messages || []) {
    if (message?.agent_id) return message.agent_id;
    if (message?.agentId) return message.agentId;
  }
  return 'default';
};
